export default __webpack_public_path__ + "static/assets/87b6045ee0eea68aef9ad8a1759e380a.svg";